import { Button, Table } from "react-bootstrap";
import CustomTableFooter from "../components/CustomTableFooter";
import Loader from "../components/Loader";
import { ExpType, rowsPerPageOptions } from "../config/config";
import { useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuItem, Select } from "@mui/material";
import { isEmpty } from "./utils";
import { Draggable, Droppable } from "react-beautiful-dnd"

export function renderUserVoteBody() {
    return (user_vote) => (user_vote === 1
        ? "Oui"
        : user_vote === -1
            ? "Non"
            : "Non-vu"
    );
}

export function renderStatusBody() {
    return (status) => (status
        ? "Oui"
        : status === null
            ? "Non-vu"
            : "Non"
    );
}

export function renderInSemanticBody() {
    return (classes) => (classes?.length > 0 ? "Oui" : "Non");
}

export function renderIsVedetteBody() {
    return (vedette_class) => ((vedette_class !== null) ? "Oui" : "Non");
}

export function renderRelationsBody() {
    return (relations) => {
        if (relations !== undefined)
            return Object.entries(relations).length
    };
}

export function renderNthHeadBody() {
    return (nth_head) => (nth_head?.reference || "");
}

export function renderExpTypeBody() {
    return (type) => (ExpType[type]);
}

export function renderExpansionBody() {
    return (expansion) => (expansion?.reference || "");
}

export function renderAnalysisBody() {
    return (analysis) => (<>[{analysis}]</>);
}

function RenderTermBody({
    referenceId, rowIndex
}) {
    const [termId, termReference] = referenceId
    const getSelectedRows = () => JSON.parse(localStorage.getItem("TermListTableState") || "{}")?.selectedRows?.data?.length

    return (
        <Droppable droppableId={`term-${termId}`} isDropDisabled={true}>
            {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                    <Draggable
                        key={termId} draggableId={`{"id": ${termId}, "type": "term"}`} index={rowIndex}
                    >
                        {(provided, snapshot) => (<div
                            style={{ cursor: "pointer" }}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            {termReference}
                            {snapshot.isDragging && getSelectedRows() !== 0 && (
                                <span className="draggable-item">{getSelectedRows()}</span>
                            )}
                        </div>)}
                    </Draggable>
                </div>
            )}
        </Droppable>
    )
}

export function renderTermBody() {
    return (referenceId, tableMeta) => <RenderTermBody
        {...{
            referenceId,
            rowIndex: tableMeta.rowIndex,
        }}
    />
}


const setNumericCellProps = () => ({
    style: {
        textAlign: "end",
    }
})

export const createColumns = () => {
    const columnsState = JSON.parse(localStorage.getItem("TermListTableState") || "{}")?.columns || []
    return [
        {
            name: "referenceId",
            label: "Terme",
            options: {
                filter: true,
                sort: true,
                customBodyRender: renderTermBody(),
            },
        },
        {
            name: "lemma",
            label: "Lemme",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "posTagging",
            label: "POS",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "language",
            label: "Langue",
            options: {
                filter: true,
                sort: false,
            },
        },
        {
            name: "analysis",
            label: "Syntaxe",
            options: {
                filter: true,
                sort: false,
                customBodyRender: renderAnalysisBody(),
            },
        },
        {
            name: "expansion",
            label: "Complément",
            options: {
                filter: false,
                sort: true,
                customBodyRender: renderExpansionBody(),
            },
        },
        {
            name: "nth_head",
            label: "Tête",
            options: {
                filter: false,
                sort: true,
                customBodyRender: renderNthHeadBody(),
            },
        },
        {
            name: "relations",
            label: "Nb termes liés",
            options: {
                filter: true,
                sort: false,
                customBodyRender: renderRelationsBody(),
                setCellProps: () => ({ style: { minWidth: "65px", textAlign: "end" } }),
            },
        },
        {
            name: "vedette_class",
            label: "Vedette",
            options: {
                filter: false,
                sort: false,
                customBodyRender: renderIsVedetteBody(),
            },
        },
        {
            name: "classes",
            label: "Membre de classe",
            options: {
                filter: false,
                sort: false,
                customBodyRender: renderInSemanticBody(),
            },
        },
        {
            name: "n_doc",
            label: "Nb docs",
            options: {
                filter: true,
                sort: true,
                setCellProps: setNumericCellProps,
            },
        },
        {
            name: "occurences",
            label: "Nb occ",
            options: {
                filter: true,
                sort: true,
                setCellProps: setNumericCellProps,
            },
        },
        {
            name: "words",
            label: "Nb mots",
            options: {
                filter: true,
                sort: true,
                setCellProps: setNumericCellProps,
            },
        },
        {
            name: "head_pdty",
            label: "Prod. tête",
            options: {
                filter: true,
                sort: true,
                setCellProps: setNumericCellProps,
            },
        },
        {
            name: "exp_pdty",
            label: "Prod. complément",
            options: {
                filter: true,
                sort: true,
                setCellProps: setNumericCellProps,
            },
        },
        {
            name: "relevanceScore",
            label: "Score",
            options: {
                filter: true,
                sort: true,
                setCellProps: setNumericCellProps,
            },
        },
        {
            name: "label",
            label: "Dataset",
            options: {
                filter: true,
                sort: false,
            },
        },
        {
            name: "engine",
            label: "Méthode",
            options: {
                filter: true,
                sort: false,
            },
        },
        {
            name: "user_vote",
            label: "Vote",
            options: {
                filter: true,
                sort: false,
                empty: true,
                customBodyRender: renderUserVoteBody(),
            },
        },
        {
            name: "status",
            label: "Validation",
            options: {
                filter: true,
                sort: false,
                empty: true,
                customBodyRender: renderStatusBody(),
                display: false,
            },
        }
    ].map((item, index) => ({
        ...item,
        options: {
            ...item.options,
            display: columnsState[index]?.display ?? item.options.display ?? true,
        }
    }));
}

function onTableChange(setRowsPerPage, changepage) {
    return (action, tableState) => {
        switch (action) {
            case "changeRowsPerPage":
                setRowsPerPage(tableState.rowsPerPage);
                changepage(
                    tableState.page,
                    tableState.rowsPerPage,
                    tableState.sortOrder
                );
                break;

            case "sort":
                changepage(
                    tableState.page,
                    tableState.rowsPerPage,
                    tableState.sortOrder
                );
                break;
            default:
                break;
        }
        localStorage.setItem("TermListTableState", JSON.stringify(tableState));
    };
}

function customFooter(thisPage, changepage) {
    return (
        count,
        page,
        rowsPerPage,
        changeRowsPerPage,
        changePage,
        textLabels
    ) => {
        return (
            <CustomTableFooter
                count={count}
                page={thisPage}
                rowsPerPage={rowsPerPage}
                changeRowsPerPage={changeRowsPerPage}
                changePage={changepage}
                textLabels={textLabels} />
        );
    };
}

function customToolbarSelect() {
    return () => <></>;
}

function setRowProps(termList, selectedTermId) {
    return (_, index) => {
        return {
            style: {
                backgroundColor: termList?.[index].id === selectedTermId ? "#b0e0e6" : "",
                cursor: "pointer",
            },
        };
    };
}

function onRowSelectionChange(setRowsSelected) {
    return (currentRowsSelected, allRowsSelected, rowsSelected) => {
        setRowsSelected(rowsSelected)
    }
}

export const createOptions = (
    termList,
    selectedTermId,
    rowsPerPage,
    count,
    onCellClick,
    isLoaded,
    thisPage,
    changepage,
    setRowsPerPage,
    rowsSelected, setRowsSelected,
    sortOrder,
) => {
    return {
        setRowProps: setRowProps(termList, selectedTermId),
        filterType: "textField",
        selectableRows: "multiple",
        filter: false,
        search: false,
        print: false,
        download: false,
        viewColumns: true,
        draggableColumns: {
            enabled: true,
            transitionTime: 100,
        },
        resizableColumns: true,
        serverSide: true,
        tableBodyHeight: "100%",
        textLabels: {
            body: {
                noMatch: isLoaded ? (
                    <Loader>Chargement des données ...</Loader>
                ) : (
                    "Désolé, il n'y a pas de données correspondantes à afficher"
                ),
            },
            toolbar: {
                viewColumns: "Affichage colonnes",
            },
            viewColumns: {
                title: "Affichage colonnes",
                titleAria: "Affichage colonnes",
            },
            pagination: {
                rowsPerPage: "Termes par page",
                displayRows: "de",
                jumpToPage: "Sauter à la page",
            },
            selectedRows: {
                text: "ligne(s) sélectionnée(s)",
                delete: "Afficher le menu",
                deleteAria: "Afficher le menu",
            },
        },
        customToolbarSelect: customToolbarSelect(),
        customFooter: customFooter(thisPage, changepage),
        rowsPerPage,
        rowsSelected,
        rowsPerPageOptions,
        sortOrder,
        count,
        onCellClick: onCellClick,
        onTableChange: onTableChange(setRowsPerPage, changepage),
        onRowSelectionChange: onRowSelectionChange(setRowsSelected),
    }
}

export const sortOrderLabel = {
    referenceId: "Terme",
    lemma: "Lemme",
    posTagging: "POS",
    relevanceScore: "Score",
    exp_pdty: "Prod. complément",
    head_pdty: "Prod. tête",
    expansion: "Complément",
    nth_head: "Tête",
    words: "Nb mots",
    documents: "Nb docs",
    occurences: "Nb occ"
};

export const CustomSort = ({
    setModelShow, setModelData,
    sortOrder, changepage,
}) => {
    const emptySortOrder = { name: "none", direction: "none" }
    const [newSortOrder, setNewSortOrder] = useState(
        sortOrder.length === 0
            ? [emptySortOrder]
            : sortOrder
    )

    return <>
        <div className="d-flex flex-column align-items-center m-3">
            <Table striped bordered hover responsive className='table-sm'>
                <thead>
                    <tr>
                        <th style={{ width: "100px" }}></th>
                        <th >Colonne</th>
                        <th >Ordre de tri</th>
                        <th style={{ width: "100px" }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {newSortOrder.map((item, index) => (
                        <tr key={`${item.name}-${item.direction}-${index}`}>
                            <td>Trier par</td>
                            <td>
                                <Select
                                    size="small"
                                    className="w-100"
                                    value={item.name}
                                    onChange={(e) => {
                                        const newSortOrder_ = [...newSortOrder];
                                        newSortOrder_[index].name = e.target.value
                                        setNewSortOrder(newSortOrder_);
                                    }}
                                >
                                    <MenuItem value="none">Select...</MenuItem>
                                    {Object.keys(sortOrderLabel).map((sortName => (
                                        <MenuItem
                                            key={sortName}
                                            value={sortName}
                                            disabled={newSortOrder.map(item => item.name).includes(sortName)}
                                        >
                                            {sortOrderLabel[sortName]}
                                        </MenuItem>
                                    )))}
                                </Select>
                            </td>
                            <td>
                                <Select
                                    size="small"
                                    className="w-100"
                                    value={item.direction}
                                    onChange={(e) => {
                                        const newSortOrder_ = [...newSortOrder];
                                        newSortOrder_[index].direction = e.target.value
                                        setNewSortOrder(newSortOrder_);
                                    }}
                                >
                                    <MenuItem value="none">Select...</MenuItem>
                                    <MenuItem value="asc">Ascendant</MenuItem>
                                    <MenuItem value="desc">Descendant</MenuItem>
                                </Select>
                            </td>
                            <td>
                                <Button
                                    size="sm"
                                    variant='danger'
                                    disabled={newSortOrder.length === 1 && newSortOrder[0].name === "none"}
                                    onClick={() => {
                                        if (newSortOrder.length > 1) {
                                            const newSortOrder_ = [...newSortOrder];
                                            newSortOrder_.splice(index, 1);
                                            setNewSortOrder(newSortOrder_);
                                        }
                                        else {
                                            setNewSortOrder([emptySortOrder])
                                        }
                                    }}
                                >
                                    <DeleteIcon />
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Button
                size="sm"
                disabled={Object.keys(sortOrderLabel).length === newSortOrder.length}
                onClick={() => {
                    const newSortOrder_ = [...newSortOrder, emptySortOrder];
                    setNewSortOrder(newSortOrder_);
                }}
            >
                <i className="fas fa-plus"></i>
            </Button>
        </div>


        <div className="d-flex align-items-center justify-content-center w-100">
            <Button
                className='m-1 p-1'
                variant='danger'
                size="sm"
                onClick={() => {
                    setModelShow(false);
                    setModelData({});
                }}
            >
                Annuler
            </Button>
            <Button
                className='m-1 p-1'
                size="sm"
                onClick={() => {
                    const newSortOrderFiltered = newSortOrder
                        .filter((sortOrder) => {
                            if (sortOrder.name === "none") return false;
                            return true;
                        })
                        .map((sortOrder) => {
                            if (sortOrder.direction === "none") sortOrder.direction = "asc"
                            return sortOrder
                        })
                    changepage(
                        undefined,
                        undefined,
                        isEmpty(newSortOrderFiltered)
                            ? [emptySortOrder]
                            : newSortOrderFiltered
                    )
                    setModelShow(false);
                    setModelData({});
                }}
            >
                Appliquer
            </Button>
        </div>
    </>
}

export const ConnectorSvg = (props) => (
    <svg
        width={12}
        height={12}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.5 1.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 0h5v12h5m0 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
            stroke="#fff"
        />
    </svg>
);
export default ConnectorSvg;